import { render, staticRenderFns } from "./road-bike-insurance.vue?vue&type=template&id=5a2f2b94&scoped=true"
import script from "./road-bike-insurance.vue?vue&type=script&lang=js"
export * from "./road-bike-insurance.vue?vue&type=script&lang=js"
import style0 from "./road-bike-insurance.vue?vue&type=style&index=0&id=5a2f2b94&prod&lang=scss&scoped=true"
import style1 from "./road-bike-insurance.vue?vue&type=style&index=1&id=5a2f2b94&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a2f2b94",
  null
  
)

export default component.exports